"use strict";
// From @basarat
// https://basarat.gitbooks.io/typescript/docs/tips/nominalTyping.html
Object.defineProperty(exports, "__esModule", { value: true });
function createId(type, value) {
    return {
        type: type,
        value: value
    };
}
exports.createId = createId;
function createIdCreator(type) {
    return function createId(value) {
        return {
            type: type,
            value: value
        };
    };
}
exports.createIdCreator = createIdCreator;
//# sourceMappingURL=Id.js.map